module.exports = require('crypto');


//////////////////
// WEBPACK FOOTER
// ./node_modules/randomhex/src/crypto.js
// module id = 1362
// module chunks = 0